import { SalesforceField } from '@/model/SalesforceField';
import AbrdnSelect, { SelectOption } from 'components/Generic/Forms/FormFields/AbrdnSelect';
import { useFormContext } from 'components/Generic/Forms/SalesforceIntegratedForms/FormContext';
import { useI18n } from 'next-localization';

const SalesforceDropdown = ({
  fields,
  stepName,
  onValueSelected,
  defaultValue,
}: Pick<SalesforceField, 'fields' | 'stepName' | 'onValueSelected' | 'defaultValue'>) => {
  const { updateFormData, updateSummary } = useFormContext();
  const { t } = useI18n();

  const dropdownOptions = fields.items.map((option) => {
    return {
      label: option.displayName,
      value: option.fields.salesforceValue.value,
    };
  });

  const handleChange = ({ value }: SelectOption<string>) => {
    onValueSelected(value);
    updateFormData({
      fieldName: fields.salesforceFieldId?.value,
      value,
    });
    updateSummary({
      fieldName: {
        storeName: fields.salesforceFieldId?.value,
        displayName: fields.title?.value,
      },
      fieldValue: value,
      stepName: stepName,
    });
  };

  return (
    <div className="mb-4" style={{ maxWidth: 480 }}>
      <AbrdnSelect
        options={dropdownOptions}
        required={fields.isRequired?.value}
        title={fields.title?.value}
        id={fields.salesforceFieldId?.value}
        placeholder={t('chooseAnOption')}
        defaultValue={defaultValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default SalesforceDropdown;
